<div class="ficha-container" *ngIf="obraNaoEncontrada">
  <div class="obra-nao-encontrada">
    <mat-icon>search_off</mat-icon>
    <h3>Obra não encontrada</h3>
    <p>
      Esta obra não existe no módulo selecionado. Ela pode ter sido removida ou
      pertencer a outro módulo.
    </p>
  </div>
</div>

<app-modal-reportar-erro-obra
  *ngIf="showReportErroObra"
  [workId]="idObra"
  [workName]="ArrObraDetalhes?.name || ''"
  [moduleId]="ArrObraDetalhes?.moduleId || null"
  [module]="getModuleName(ArrObraDetalhes?.moduleId)"
  [constructorId]="getConstructorCompanyId()"
  [constructorName]="getConstructorName(getConstructorCompanyId())"
  [companyId]="companyId"
  [companyName]="companyName"
  (close)="fecharReportErroObra()"
  (loading)="loadingObra.emit(!!$event)"
></app-modal-reportar-erro-obra>

<app-modal-aguardando-download
  *ngIf="processandoAcao"
  [mensagem]="mensagemProcessando"
></app-modal-aguardando-download>
